import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

export const approveReserveOrderLink = async (
  proposalId: string
): Promise<any> => {
  return axios.post(
    `/orders/proposals/${proposalId}/approve-reserve-order-link`
  )
}

type Params = {
  onSuccess?: () => void
}

export function useApproveReserveOrderLink({ onSuccess }: Params = {}) {
  const queryClient = useQueryClient()
  return useMutation(approveReserveOrderLink, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      queryClient.invalidateQueries('proposal')
      queryClient.invalidateQueries('orderReviewReasons')
      toast.success('Vínculo com pedido reserva aprovado com sucesso!')
      onSuccess?.()
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível aprovar o vínculo com pedido reserva!')
    }
  })
}
